var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTrailerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23 19.9",
    style: {
      enableBackground: "new 0 0 23 19.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.5,15.3v-0.6h-1v0.6H4.4v-0.6h-1v0.6H0.8V16v0.3v0.5v0.1v0.8h1.8c0,1.1,0.9,2,2,2s2-0.9,2-2h0.3 c0,1.1,0.9,2,2,2s2-0.9,2-2h0.4v0.7v0.1v0.4c0,0.1,0.1,0.2,0.2,0.2h3.2c0.1,0,0.2-0.1,0.2-0.2v-0.4l0,0l0,0v-0.7h0.4v-0.9h-4.7 c-0.1-0.2-0.2-0.4-0.4-0.5h10.2v2.7h0.9v-2.7v-0.5v-0.5h-5.8V15.3z M12.1,17.6H14v0.5h-1.9V17.6z M2.8,16.8H1.7v-0.5h1.5 C3,16.4,2.9,16.6,2.8,16.8z M4.6,18.5c-0.5,0-0.9-0.4-0.9-0.9c0-0.4,0.2-0.7,0.6-0.9c0.1,0,0.2-0.1,0.3-0.1s0.2,0,0.3,0.1 c0.3,0.1,0.6,0.5,0.6,0.9C5.5,18.1,5.1,18.5,4.6,18.5z M7.1,16.8H6.4c-0.1-0.2-0.2-0.4-0.4-0.5h1.5C7.3,16.4,7.2,16.6,7.1,16.8z  M8.8,18.5c-0.5,0-0.9-0.4-0.9-0.9c0-0.4,0.2-0.7,0.6-0.9c0.1,0,0.2-0.1,0.3-0.1s0.2,0,0.3,0.1c0.3,0.1,0.6,0.5,0.6,0.9 C9.8,18.1,9.4,18.5,8.8,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.6,17.3c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4S5,17.8,5,17.6C5,17.4,4.8,17.3,4.6,17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.8,17.3c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4C9.2,17.5,9,17.3,8.8,17.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.9,14.1c-2,0-3.8-0.8-5.2-2v1H9.2v-2.9c-0.5-0.9-0.9-2-1-3.1H7.5v6H5.8V7H4.2v6H2.5V6.2h5.7 c0-0.6,0.1-1.2,0.2-1.7H0.8v10.2h18.4c0,0,0-1.1,0-1.4C18.2,13.8,17.1,14.1,15.9,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.6,2.7c-0.3-0.4-0.6-0.7-1-1c-0.4-0.3-0.8-0.5-1.2-0.7c-0.1,0-0.2-0.1-0.2-0.1c-0.7-0.3-1.4-0.4-2.2-0.4H16 c-3.2,0-5.8,2.6-5.8,5.8v0.1c0,3.2,2.6,5.8,5.8,5.8h0.1c3.2,0,5.8-2.6,5.8-5.8V6.3C21.8,4.9,21.4,3.7,20.6,2.7z M20.4,7.1H17v3.5 h-1.6c0,0,0-3.5,0-3.5h-3.5V5.5h3.5V2H17v3.5h3.5V7.1L20.4,7.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTrailerIcon);
export default __webpack_public_path__ + "static/media/new-trailer-icon.77c63d35a0d9a40d603972bd770fdfb5.svg";
export { ForwardRef as ReactComponent };